import { render, staticRenderFns } from "./About.vue?vue&type=template&id=6e912e5d&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e912e5d')) {
      api.createRecord('6e912e5d', component.options)
    } else {
      api.reload('6e912e5d', component.options)
    }
    module.hot.accept("./About.vue?vue&type=template&id=6e912e5d&", function () {
      api.rerender('6e912e5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/about/About.vue"
export default component.exports